import { render, staticRenderFns } from "./Dissertation_council.vue?vue&type=template&id=1952bb12&scoped=true"
import script from "./Dissertation_council.vue?vue&type=script&lang=js"
export * from "./Dissertation_council.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952bb12",
  null
  
)

export default component.exports